import { render, staticRenderFns } from "./subscribeOther.vue?vue&type=template&id=16a4df97&scoped=true&"
import script from "./subscribeOther.vue?vue&type=script&lang=js&"
export * from "./subscribeOther.vue?vue&type=script&lang=js&"
import style0 from "./subscribeOther.vue?vue&type=style&index=0&id=16a4df97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4df97",
  null
  
)

export default component.exports